import { __spreadArray } from "tslib";
import { ApiTypes } from '../sdk.types';
function extendWithAllResults(documentTypes) {
    return __spreadArray(__spreadArray([], (documentTypes.length > 1
        ? [{ documentType: ApiTypes.SearchDocumentType.All }]
        : [])), documentTypes);
}
export function parseDocumentTypes(documentTypes) {
    return extendWithAllResults(documentTypes);
}
//# sourceMappingURL=documentTypes.js.map